export default __webpack_public_path__ + "static/media/card1600.bff56489.jpg";